
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";

@Component
export default class SearchFilter extends Vue {
  @Prop()
  value!: boolean;

  toggle() {
    this.$emit("input", !this.value);
  }
}
